import Base from './Base'

export class Footer extends Base {
    constructor(props) {
        super(props);
    }
    render() {
        return null
    }
}